import { writable } from 'svelte/store';
import _orderBy from 'lodash-es/orderBy';

import { busyState } from './busy';

// import {items as examples} from '../config/examples.yaml';

const DEFAULT_STATE_VISIBLE = [];
const DEFAULT_STATE_ITEMS = [];

class ItemStore {
    constructor() {
        this.visibleStore = writable(DEFAULT_STATE_VISIBLE);
        this.itemsStore = writable(DEFAULT_STATE_ITEMS);
    }

    async _getItems() {
        /*
         * @NB: Example data from config/examples.yaml for testing purposes with a fake delay
         * Don't forget to uncomment the actual getter below and the import above
         */
        // await busyState.exec(async () => {
        //     await new Promise((res) => {
        //         window.setTimeout(
        //             () => {
        //                 this.itemsStore.update(() => examples);
        //                 res();
        //             },
        //             1200
        //         );
        //     });
        // });

        await busyState.exec(() => {
            try {
                const rawItems = JSON.parse(
                    document.getElementById('faq').innerText.trim()
                );
                const withParsedContent = rawItems.map((item) => {
                    return {
                        ...item,
                        content: item.content,
                    };
                });
                const items = _orderBy(withParsedContent, ['title'], 'asc');
                this.itemsStore.update(() => items);
                // Default state: Show all existing items:
                this.visibleStore.update(() => items);
            } catch (e) {
                console.error('No FAQ item definitions found!');
            }
        });
    }

    updateVisibleItems(items = DEFAULT_STATE_VISIBLE) {
        this.visibleStore.update(() => items);
    }

    get subscribeVisible() {
        return this.visibleStore.subscribe;
    }

    get subscribeItems() {
        return this.itemsStore.subscribe;
    }
}

const internalItemStore = new ItemStore();
internalItemStore._getItems().then();

export const itemStore = internalItemStore;
